import { useContext } from 'react';
import { UserContext } from '../contexts/user.context';
import { UserProviderValue } from '../models';
import { usePageRestriction } from '../hooks';
import { SignupWeb2 } from '../components';

export function SignupPage() {
   const { isAuthenticated } = useContext<UserProviderValue>(UserContext);
   usePageRestriction('unauthenticated', '/', isAuthenticated);

   return <SignupWeb2 />;
}
